import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/TeardownScreen'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class TeardownScreenStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "TeardownScreenStore",
			variables: true,
		})
	}
}

export async function load_TeardownScreen(params) {
  await initClient()

	const store = new TeardownScreenStore()

	await store.fetch(params)

	return {
		TeardownScreen: store,
	}
}
